import {
  conversationStep,
  noConversation,
  settingButton,
  chatSectionStep,
  vanillaVMSteps,
  userFormatSteps,
  userFormatElseStep,
  promptsStep,
  promptElseStep,
  filesSteps,
  noFilesSteps,
  sharedFilesSteps,
  noSharedFilesSteps,
  docsSteps,
  imageSteps,
  imageFileSteps,
  imageElseSteps,
  collectionSteps,
  imageGenerationSteps,
  allTypeSteps,
  webSteps,
} from "../components/JoyRideSteps";

const TYPE_CONFIGS = {
  // Match name with all with constants component
  Web: {
    typeSteps: webSteps,
    excludeIndex: 0,
    includeFiles: false,
    includeSharedFiles: false,
    userFormatSteps: true,
    promptsStep: true,
  },
  GPT: {
    typeSteps: vanillaVMSteps,
    excludeIndex: 1,
    includeFiles: false,
    includeSharedFiles: false,
    userFormatSteps: true,
    promptsStep: true,
  },
  "DOCS GPT": {
    typeSteps: docsSteps,
    excludeIndex: 2,
    includeFiles: true,
    includeSharedFiles: true,
  },
  Image: {
    typeSteps: imageSteps,
    excludeIndex: 3,
    includeFiles: true,
    includeSharedFiles: false,
    useImageSteps: true,
  },
  Collections: {
    typeSteps: collectionSteps,
    excludeIndex: 4,
    includeFiles: false,
    includeSharedFiles: false,
  },
  "Image Generator": {
    typeSteps: imageGenerationSteps,
    excludeIndex: 5,
    includeFiles: false,
    includeSharedFiles: false,
  },
};

const newConversationStep = {
  target: "#newconversation",
  content:
    "Click on the 'New Conversation' button to start a new chat. It will be added to your conversation list and automatically named 'New Chat' by default.",
  disableBeacon: true,
};

function addConditionalSteps(steps, condition, trueSteps, falseSteps) {
  return steps.concat(condition ? trueSteps : falseSteps);
}

export function generateJoyRideSteps(
  conversation,
  conversationId,
  type,
  userFormats,
  prompts,
  files,
  shared_files
) {
  let steps = [newConversationStep];

  // Add conversation steps
  steps = addConditionalSteps(
    steps,
    conversation?.length > 0,
    conversationStep,
    [noConversation]
  );
  steps.push(settingButton);

  // Add chat section if conversation exists
  if (conversationId) {
    steps = steps.concat(chatSectionStep);
  }

  const config = TYPE_CONFIGS[type];

  console.log("config", config);

  if (config) {
    // Add type-specific steps
    steps = steps.concat(config.typeSteps);

    // Add file steps if applicable
    if (config.includeFiles) {
      if (config.useImageSteps) {
        steps = steps.concat(
          files?.length > 0 ? imageFileSteps : [imageElseSteps]
        );
      } else {
        steps = steps.concat(files?.length > 0 ? filesSteps : [noFilesSteps]);
      }
    }

    // Add shared file steps if applicable
    if (config.includeSharedFiles) {
      steps = addConditionalSteps(
        steps,
        shared_files?.length > 0,
        sharedFilesSteps,
        [noSharedFilesSteps]
      );
    }
    // Add user format and prompt steps based on config
    if (config.userFormatSteps !== undefined) {
      steps = addConditionalSteps(
        steps,
        config.userFormatSteps,
        userFormatSteps,
        [userFormatElseStep]
      );
    } else {
      steps = addConditionalSteps(
        steps,
        userFormats?.length > 0,
        userFormatSteps,
        [userFormatElseStep]
      );
    }

    if (config.promptsStep !== undefined) {
      steps = addConditionalSteps(steps, config.promptsStep, promptsStep, [
        promptElseStep,
      ]);
    } else {
      steps = addConditionalSteps(steps, prompts?.length > 0, promptsStep, [
        promptElseStep,
      ]);
    }

    // Add remaining type steps (exclude current type)
    steps = steps.concat(
      allTypeSteps.filter((_, index) => index !== config.excludeIndex)
    );
  } else if (!type) {
    // Show all types when no specific type is selected
    steps = steps.concat(allTypeSteps);
  }

  return steps;
}
